import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> SOC</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>SOC 1 / SOC 2 / SOC 3 Compliance</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  In today’s highly regulated and trust-driven business
                  environment, organizations must prove they have effective
                  controls to protect financial data, customer information, and
                  digital services. SOC 1, SOC 2, and SOC 3 Compliance,
                  developed by the AICPA, are globally recognized frameworks
                  that validate your internal controls, security, and data
                  protection practices. Achieving SOC compliance builds trust,
                  ensures regulatory readiness, and demonstrates your commitment
                  to transparency, security, and operational excellence.
                </p>
              </div>

              {/* Why It Matters */}
              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Financial Accuracy & Control",
                    desc: "Ensure your systems and processes related to financial reporting are reliable and fraud-resistant.",
                  },
                  {
                    icon: "fa-database",
                    title: "Data Security Assurance",
                    desc: "Prove to clients and regulators that you safeguard sensitive information.",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "Client & Partner Confidence",
                    desc: "Many enterprises require SOC reports before doing business.",
                  },
                  {
                    icon: "fa-table",
                    title: "Regulatory Alignment",
                    desc: "Supports compliance with SOX, GDPR, HIPAA, PCI DSS, ISO, PCAOB and other frameworks.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Competitive Edge",
                    desc: "SOC reports enhance credibility, reduce sales friction, and accelerate business growth.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* SOC Types */}
              <div className="heading-in mb-5">
                <p>
                  <b className="sub-heading">SOC Compliance Types</b>
                  <br />
                  <b>SOC 1 – Financial Reporting Assurance</b><br />
                  Focuses on internal controls over financial reporting.<br />
                  <b>
                    • Type I: Evaluates control design at a specific point in time.<br />
                    • Type II: Tests operating effectiveness over 6–12 months.
                  </b>
                </p>
              </div>
              <div className="heading-in mb-5">
                <p>
                  <b className="sub-heading">SOC 2 – Security & Privacy Assurance</b>
                  <br />
                  Focuses on the Trust Services Criteria (Security, Availability, Processing Integrity, Confidentiality, Privacy).<br />
                  <b>
                    • Type I: Validates that controls are properly designed.<br />
                    • Type II: Proves controls are effective in real-world operations.
                  </b>
                  <br />
                  Essential for SaaS, cloud, fintech, IT providers, and healthcare organizations.
                </p>
              </div>
              <div className="heading-in mb-5">
                <p>
                  <b className="sub-heading">SOC 3 – Public Trust & Transparency</b>
                  <br />
                  Based on SOC 2, but designed for a general audience with a publicly shareable report & trust seal.<br />
                  <b>
                    • Type I & II: Demonstrates design and effectiveness of controls.
                    Perfect for companies wanting to showcase compliance on their website, proposals, and marketing.
                  </b>
                </p>
              </div>

              {/* Tabs */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>Our structured SOC compliance roadmap ensures smooth and successful certification:</p>
                      <ul>
                        <li><b>Scoping & Gap Assessment :-</b> Identify relevant processes, systems, and controls.</li>
                        <li><b>Control Design Review :-</b> Evaluate policies, procedures, and safeguards against SOC standards.</li>
                        <li><b>Readiness Assessment :-</b> Highlight compliance gaps and provide a remediation plan.</li>
                        <li><b>Remediation Support :-</b> Strengthen and formalize controls.</li>
                        <li><b>Audit Preparation :-</b> Build audit-ready documentation and evidence.</li>
                        <li><b>Audit Support :-</b> Partner with auditors for SOC 1, 2, or 3 certification.</li>
                        <li><b>Final Report Delivery :-</b> Provide complete, client-ready reports and assurance documentation.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <ul>
                        <li>Strengthen trust with clients, investors, and regulators.</li>
                        <li>Gain audit-ready evidence and reduce compliance costs.</li>
                        <li>Demonstrate operational maturity and transparency.</li>
                        <li>Win more business by meeting vendor security requirements.</li>
                        <li>Build long-term resilience against financial, security, and compliance risks.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>You will receive:</p>
                      <ul>
                        <li>SOC 1 / 2 / 3 Gap Assessment Report with remediation roadmap.</li>
                        <li>Control Design Documentation aligned with SOC requirements.</li>
                        <li>Customized Risk & Control Matrix (RCM).</li>
                        <li>Audit-Ready Evidence Repository.</li>
                        <li>SOC 1, SOC 2, or SOC 3 Readiness Report (Type I or Type II).</li>
                        <li>Remediation Guidance with prioritized actions.</li>
                        <li>Executive Summary Report for stakeholders and clients.</li>
                        <li>SOC 3 Public Trust Seal (if applicable) for use on website and marketing.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Our Approach */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach</h3>
                  <ul>
                    <li><b>Deep Expertise :-</b> Specialists in SOC 1, SOC 2, and SOC 3 across industries.</li>
                    <li><b>Financial & Security Knowledge :-</b> Controls aligned with SOX, PCAOB, GDPR, HIPAA, PCI DSS, ISO.</li>
                    <li><b>End-to-End Partner :-</b> From gap assessment to audit coordination.</li>
                    <li><b>Tailored Solutions :-</b> Customized compliance strategies for SaaS, fintech, healthcare, BPO, and IT service providers.</li>
                    <li><b>Proven Success :-</b> Delivered SOC compliance projects for organizations worldwide.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
